<template>
  <!--
    The view for the Time Compensation Report generation
  -->
  <HomeOfficeReport />
</template>

<script>
export default {
  name: "TimeCompensationReportView",
  components: {
    HomeOfficeReport: () => import('@/components/CustomerWorklog/TimeCompensationReport.vue')
  },
  metaInfo () {
    return {
      title: 'Time Compensation Report'
    }
  }
}
</script>
